import { ISimpleTableField, simpleTableSortFn } from "@asup/simple-table";
import { eHierarchyLevel } from "functions/api/enums";
import { SearchResultsHeaders, SearchTocHeaders } from "./searchResultsHeaders";
import { templateHeaders } from "./templateHeaders";
import { TocHeaders } from "./tocHeaders";

/**
 * Returns appropriate table header configuration based on display mode and hierarchy level.
 *
 * @param showSearchResults - Whether displaying general search results
 * @param showTocSearchResults - Whether displaying TOC search results
 * @param hierarchyLevel - Current hierarchy level
 * @param showExport - Whether displaying export selection columns
 * @param showVariantName - Whether to include a column for Master or named variant output
 */
export const getTemplateHeaders = (
  showSearchResults: boolean,
  showTocSearchResults: boolean,
  hierarchyLevel: eHierarchyLevel,
  showExport = false,
  showVariantName = false,
): ISimpleTableField[] => {
  const headers = showExport
    ? SearchResultsHeaders.filter(
        (field) => field.name !== "tlfTagValues" && field.name !== "additionalInformation",
      )
    : showSearchResults
      ? SearchResultsHeaders
      : showTocSearchResults
        ? SearchTocHeaders
        : hierarchyLevel === eHierarchyLevel.Report
          ? TocHeaders
          : templateHeaders(hierarchyLevel);
  return showVariantName
    ? [
        ...headers.slice(0, 1),
        {
          canColumnFilter: true,
          label: "Variant",
          name: "variantName",
          sortFn: simpleTableSortFn,
        },
        ...headers.slice(1),
      ]
    : headers;
};
